import { Button, Group } from "@mantine/core";

interface StepNavigationProps {
  onNext?: () => void;
  onBack?: () => void;
  isSubmitting?: boolean;
  backLabel?: string;
  nextLabel?: string;
}

export const StepNavigation = ({
  onNext,
  onBack,
  isSubmitting = false,
  backLabel = "Précédent",
  nextLabel = "Suivant",
}: StepNavigationProps) => (
  <Group w="100%" justify={onBack ? "space-between" : "flex-end"} mt="xl">
    {onBack && (
      <Button variant="outline" disabled={isSubmitting} onClick={onBack}>
        {backLabel}
      </Button>
    )}
    {onNext && (
      <Button loading={isSubmitting} onClick={onNext}>
        {nextLabel}
      </Button>
    )}
  </Group>
);
